import { Floor } from '../../types';
import api from '../../utils/api';

export const createFloor = (variables: Floor) =>
  api.post({
    url: `/floor`,
    variables,
  });
